import Image from "next/image";

function Feature({ f }) {
  return (
    <div className="feature flex items-center">
      <div className="relative mr-4 h-8 w-8">
        <Image className="object-contain" fill src={f.image} alt="ikona" />
      </div>
      <div className="text-2xl">{f.text}</div>
    </div>
  );
}

export default Feature;
